import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  AgrNotificationEmptyModule,
  AgrPageSidesheetModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { ActiveIngredientSettingsComponent } from './components/activeingredientsetting/activeingredientsetting.component';

import { ActiveIngredientSettingsDialogComponent } from './components/activeingredientsetting-dialog/activeingredientsetting-dialog.component';

import { ActiveIngredientSettingsEffects } from './store/effects/activeingredientsetting.effects';
import { activeIngredientSettingsReducer } from './store/reducers/activeingredientsetting.reducer';

@NgModule({
  declarations: [ActiveIngredientSettingsComponent, ActiveIngredientSettingsDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatAutocompleteModule,
    AgrTableModule,
    AgrDialogModule,
    AgrPageSidesheetModule,
    AgrNotificationEmptyModule,
    AgrResponsiveActionsModule,
    AgrTableModule,
  ],
  providers: [
    provideState('activeingredientsettings', activeIngredientSettingsReducer),
    provideEffects(ActiveIngredientSettingsEffects),
  ],
})
export class ActiveIngredientSettingsModule {}
